import {format} from 'date-fns';

/**
 * Formats a date using the specified format string.
 *
 * @param date - The date to format (Date object, timestamp, or ISO string).
 * @param formatStr - The format pattern (e.g. 'dd/MM/yyyy', 'yyyy-MM-dd HH:mm').
 * @returns The formatted date string.
 *
 * @see https://date-fns.org/docs/format for supported format tokens.
 */
export function formatDate(date: Date | number | string, formatStr: string): string {
    const parsedDate = typeof date === 'string' ? new Date(date) : date;

    return format(parsedDate, formatStr);
}
